import React from 'react'
import { styled } from '@mui/system';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import BusinessIcon from '@mui/icons-material/Business';
import CopyrightIcon from '@mui/icons-material/Copyright';


const Container = styled('section')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: '40vh',
  background: 'linear-gradient(var(--color-primary),var(--color-bg-variant))',
  padding: '100px',
  justifyContent: 'center',
  gap: '20px',
  marginTop: '10vh'
})

const Title = styled('h1')({
  fontSize: '24px',
  color: 'var(--color-bg)'
})

const PagesContainer = styled('div')({
  display: 'flex',
  gap: '10px',
  '@media (max-width: 1020px)' : {
    flexDirection: 'column',
    alignItems : 'center'
}
})

const Page = styled('a')({
  fontSize: '18px',
  fontWeight: '500',
  color: 'var(--color-bg)',
  textDecoration: 'none',
  transition: 'all 0.5s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  },
})

const IconContainer = styled('div')({
  display: 'flex'
})

const SocialIcon = styled('div')({
  height: '40px',
  width: '40px',
  borderRadius: '20%',
  color: 'var(--color-white)',
  backgroundColor: 'var(--color-bg)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.5s ease',
  margin: '10px',
  '&:hover': {
    transform: 'scale(1.1)',
  },
})

const ContentContainer = styled('div')({
  display: 'flex',
  alignItems: 'center'
})


const Content = styled('p')({
  fontSize: '14px',
  fontWeight: '500',
  color: 'var(--color-bg)'
})


function Footer() {
  return (
    <Container id='footer'>
      <Title>SONIA REFFAD DEV</Title>
      <PagesContainer>
        <Page href='#header'>Home</Page>
        <Page href='#about'>About</Page>
        <Page href='#experience'>Experience</Page>
        <Page href='#education'>Education</Page>
        <Page href='#services'>Services</Page>
        <Page href='#portfolio'>Portfolio</Page>
        <Page href='#contact'>Contact</Page>
      </PagesContainer>
      <IconContainer>
        <a href='https://www.linkedin.com/in/sonia-reffad-56091916b/' target="_blank" rel="noreferrer">
          <SocialIcon>
            <LinkedInIcon />
          </SocialIcon>
        </a>
        <a href='https://github.com/soniareffadpro' target="_blank" rel="noreferrer">
          <SocialIcon>
            <GitHubIcon />
          </SocialIcon>
        </a>
        <a href='https://www.societe.com/societe/madame-sonia-reffad-989521521.html' target="_blank" rel="noreferrer">
          <SocialIcon>
            <BusinessIcon />
          </SocialIcon>
        </a>
      </IconContainer>
      <ContentContainer>
        <CopyrightIcon style={{ color: 'var(--color-bg)' }} />
        <Content>Sonia Reffad 2025, All Rights Reserved</Content>
      </ContentContainer>
    </Container>
  )
}

export default Footer